import React, { Component } from 'react'
import HistoricoDRCLatex from './HistoricoDRCLatex';
import HistoricoDRCSolidos from './HistoricoDRCSolidos';
import { FiltrosFecha } from '../../../Utils/Filters';
import Tabs, { TabPane } from "rc-tabs";
import CardEmpty from '../../../Utils/Cards/CardEmpty';
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import { verificarPermisosModulo } from '../../../Utils/Auth/Auth';

/**
 * Componente para mostrar el historial de DRC en Latex y Solidos
 * Este reporte mostrará a detalle las variaciones de DRC aplicadas en los análisis de laboratorio
 * @returns {JSX.Element} componente de historial de DRC en Latex y Solidos
 */
export default class LaboratoriosDRCClass extends Component {
    componentWillMount() {
        const { setTab, tab, page } = this.props;
        if (tab === 'SÓLIDOS' || tab === 'LÁTEX') {
            setTab(tab, 'finalizados', page);
        } else {
            setTab('LÁTEX', 'finalizados', page);
        }

        // Verifica permisos
        verificarPermisosModulo(this.props, 'laboratorios_drc');
    }

    render() {
        // Datos Latex
        const { data_latex_historico } = this.props;
        const {
            fecha_inicial_finalizados_latex, fecha_final_finalizados_latex,
            fechaInicialFinalizadosLatexChange, fechaFinalFinalizadosLatexChange,
        } = this.props;

        // Datos Sólidos
        const { data_solido_historico } = this.props;
        const {
            fecha_inicial_finalizados_solido, fecha_final_finalizados_solido,
            fechaInicialFinalizadosSolidoChange, fechaFinalFinalizadosSolidoChange,
        } = this.props;

        const { setTab, tab, page } = this.props;

        return (
            <div className="mb-4 col-12">
                <Tabs
                    activeKey={tab}
                    tabBarPosition="top"
                    onChange={tab => { setTab(tab, 'finalizados') }}
                    renderTabBar={() => <TabBar />}
                    renderTabContent={() => <TabContent />}
                >
                    <TabPane tab="LÁTEX" key="LÁTEX">
                        <CardEmpty noShadow>
                            <FiltrosFecha {...this.props}
                                fecha_inicial={fecha_inicial_finalizados_latex} fecha_final={fecha_final_finalizados_latex}
                                fechaInicioChange={fechaInicialFinalizadosLatexChange} fechaFinChange={fechaFinalFinalizadosLatexChange}
                            />
                            <HistoricoDRCLatex dataLatex={data_latex_historico} {...this.props} />
                        </CardEmpty>
                    </TabPane>
                    <TabPane tab="SÓLIDOS" key="SÓLIDOS">
                        <CardEmpty noShadow>
                            <FiltrosFecha {...this.props}
                                fecha_inicial={fecha_inicial_finalizados_solido} fecha_final={fecha_final_finalizados_solido}
                                fechaInicioChange={fechaInicialFinalizadosSolidoChange} fechaFinChange={fechaFinalFinalizadosSolidoChange}
                            />
                            <HistoricoDRCSolidos dataSolidos={data_solido_historico} {...this.props} />
                        </CardEmpty>
                    </TabPane>
                </Tabs>
            </div>
        )
    }
}
